module.exports = __webpack_public_path__ + "img/present.4fcc03ca.svg";